import algoliasearch from "algoliasearch";

const {
  REACT_APP_ALGOLIA_APP_LIST_INDEX_NAME,
  REACT_APP_ALGOLIA_APP_LINK_LIST_INDEX_NAME,
  REACT_APP_ALGOLIA_SEARCH_KEY,
  REACT_APP_ALGOLIA_APP_ID,
  REACT_APP_ALGOLIA_PAGINATION_LIMIT
} = process.env;

const searchClient = algoliasearch(
  REACT_APP_ALGOLIA_APP_ID || "",
  REACT_APP_ALGOLIA_SEARCH_KEY || ""
);

export const fetchAppListData = async (
  searchText: string,
  page: number,
  hitsPerPage: number,
  filters: string
) => {
  try {
    const appListIndex: any = REACT_APP_ALGOLIA_APP_LIST_INDEX_NAME;
    const index = searchClient.initIndex(appListIndex);
    await searchClient.clearCache();

    index.setSettings({
      paginationLimitedTo: Number(REACT_APP_ALGOLIA_PAGINATION_LIMIT)
    })

    const result: any = await index.search(searchText, {
      filters: filters,
      hitsPerPage: hitsPerPage,
      page: page,
    });

    return result;
  } catch (err) {
    console.log(err);
  }
};

export const setSettingsAppListIndex = async (
  sortField: string,
  sortDirection: string
) => {
  const appListIndex: any = REACT_APP_ALGOLIA_APP_LIST_INDEX_NAME;
  const index = searchClient.initIndex(appListIndex);

  await index
    .setSettings({
      ranking: [`${sortDirection}(${sortField})`],
    })
    .wait();
};

export const fetchAppLinkListData = async () => {
  try {
    const appListIndex: any = REACT_APP_ALGOLIA_APP_LINK_LIST_INDEX_NAME;
    const index = searchClient.initIndex(appListIndex);

    const result: any = await index.search("", {
      filters: "",
      hitsPerPage: 10000,
    });

    return result?.hits;
  } catch (err) {
    console.log(err);
  }
};

